import { render } from "./KemaskiniOlehKeraniKaunter.vue?vue&type=template&id=30254118"
import script from "./KemaskiniOlehKeraniKaunter.vue?vue&type=script&lang=js"
export * from "./KemaskiniOlehKeraniKaunter.vue?vue&type=script&lang=js"

import "./KemaskiniOlehKeraniKaunter.vue?vue&type=style&index=0&id=30254118&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__